import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { WorkspaceSearch } from "@/pages/workspace/providers/WorkspaceProvider";

interface UseFilesTabEffectsProps {
  setSearch: React.Dispatch<React.SetStateAction<WorkspaceSearch>>;
}

/**
 * Hook for managing side effects in FilesTab
 *
 * Handles component-level side effects such as:
 * - Search reset when navigating between folders
 * - Other location-based state synchronization
 *
 * This hook centralizes all useEffect logic for the FilesTab component,
 * making it easier to manage and test side effects.
 */
export const useFilesTabEffects = ({
  setSearch,
}: UseFilesTabEffectsProps): void => {
  const location = useLocation();

  // Effect: Reset search when location state indicates reset
  useEffect(() => {
    if (location.state?.resetSearch) {
      setSearch((prev) => ({ ...prev, searchString: "" }));
      location.state.resetSearch = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.resetSearch, setSearch]);
};
